import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";
import { ShoppingCart, User } from "lucide-react";

export default function DashboardCharts() {
  const [period, setPeriod] = useState("Week");

  const data = [
    { day: "26 Sunday", orders: 0, customers: 0 },
    { day: "27 Monday", orders: 0, customers: 0 },
    { day: "28 Tuesday", orders: 0, customers: 0 },
    { day: "29 Wednesday", orders: 0, customers: 0 },
    { day: "30 Thursday", orders: 0, customers: 0 },
    { day: "31 Friday", orders: 0, customers: 0 },
    { day: "1 Saturday", orders: 0, customers: 0 },
    { day: "2 Sunday", orders: 0, customers: 7 },
  ];

  const periods = ["Year", "Month", "Week"];

  return (
    <div className="p-4 sm:p-6 lg:p-10 bg-gray-50 min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Orders Chart */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6">
          {/* Header */}
          <div className="flex flex-wrap justify-between items-center border-b border-gray-200 pb-2 mb-4">
            <div className="flex items-center gap-2">
              <ShoppingCart className="text-gray-600" size={20} />
              <h2 className="text-lg font-semibold text-gray-700">Orders</h2>
            </div>
            <div className="flex gap-2">
              {periods.map((p) => (
                <button
                  key={p}
                  onClick={() => setPeriod(p)}
                  className={`px-3 py-1 text-sm font-medium rounded ${
                    period === p
                      ? "bg-sky-500 text-white"
                      : "bg-white border border-sky-400 text-sky-500 hover:bg-sky-50"
                  }`}
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          {/* Chart */}
          <div className="h-64 sm:h-72 lg:h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="day" tick={{ fontSize: 12 }} />
                <YAxis domain={[-1, 1]} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="orders"
                  stroke="#38bdf8"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* New Customers Chart */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6">
          {/* Header */}
          <div className="flex flex-wrap justify-between items-center border-b border-gray-200 pb-2 mb-4">
            <div className="flex items-center gap-2">
              <User className="text-gray-600" size={20} />
              <h2 className="text-lg font-semibold text-gray-700">New customers</h2>
            </div>
            <div className="flex gap-2">
              {periods.map((p) => (
                <button
                  key={p}
                  onClick={() => setPeriod(p)}
                  className={`px-3 py-1 text-sm font-medium rounded ${
                    period === p
                      ? "bg-sky-500 text-white"
                      : "bg-white border border-sky-400 text-sky-500 hover:bg-sky-50"
                  }`}
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          {/* Chart */}
          <div className="h-64 sm:h-72 lg:h-80">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="day" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="customers"
                  stroke="#22c55e"
                  fill="#86efac"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}/>
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
